import React, {useState, useRef, useEffect} from 'react'
import {KTSVG} from '../KTSVG'

interface DropdownItem {
 label: string
 iconPath?: string
 onClick?: (arg?: string) => void
 divider?: boolean
 value?: string
}

interface Props {
 trigger: React.ReactNode
 items: DropdownItem[]
 className?: string
 menuClassName?: string
}

const MenuDropdown = ({
 trigger,
 items,
 className = '',
 menuClassName = '',
}: Props) => {
 const [open, setOpen] = useState(false)
 const ref = useRef<HTMLDivElement>(null)

 // Close on outside click
 useEffect(() => {
  const handleClickOutside = (event: MouseEvent) => {
   if (
    ref.current &&
    !ref.current.contains(event.target as Node)
   ) {
    setOpen(false)
   }
  }
  document.addEventListener('mousedown', handleClickOutside)
  return () => {
   document.removeEventListener(
    'mousedown',
    handleClickOutside
   )
  }
 }, [])

 return (
  <div ref={ref} className={`relative ${className}`}>
   {/* Trigger */}
   <div
    onClick={() => setOpen((prev) => !prev)}
    className='cursor-pointer inline-flex items-center'
   >
    {trigger}
   </div>

   {/* Dropdown Menu */}
   {open && (
    <div
     className={`absolute right-0 mt-2 w-[220px] bg-white rounded-xl shadow-lg border border-[#E6EBF0] z-50 ${menuClassName}`}
    >
     {items.map((item, index) => {
      const isLast = index === items.length - 1

      return (
       <div
        key={index}
        className={` ${
         !isLast ? 'border-b border-[#E6EBF0]' : ''
        }`}
       >
        <div
         onClick={() => {
          item.onClick?.(item?.value)
          setOpen(false)
         }}
         className='flex items-center font-semibold gap-3 px-6 py-3 text-sm text-[#33393D] hover:bg-[#F5F8FA] cursor-pointer w-full'
        >
         {item.iconPath && (
          <KTSVG
           path={item.iconPath}
           svgClassName='w-4 h-4'
          />
         )}
         <span>{item.label}</span>
        </div>
       </div>
      )
     })}
    </div>
   )}
  </div>
 )
}

export {MenuDropdown}
